const playback_schema = {
	$id: 'playback',
	type: 'object',
	properties: {
		fade_duration: {
			name: 'fade_duration',
			label: 'fade',
			type: 'number',
			minimum: 0,
			maximum: 60,
			step: 0.1,
			natural_step: 1,
			initial: 0,
			labelIcon: 'ms/autoplay',
			tip: 'How long to transition between presets',
		},
		hold_duration: {
			name: 'hold_duration',
			label: 'hold',
			type: 'number',
			minimum: 0,
			maximum: 3600,
			step: 0.1,
			natural_step: 1,
			initial: 10,
			labelIcon: 'ms/autopause',
			tip: 'How long to hold each preset',
		},
		instant: {
			name: 'instant',
			label: 'instant',
			type: 'boolean',
			initial: false,
		},
		loop: {
			name: 'loop',
			label: 'loop',
			type: 'boolean',
			initial: true,
		},
		playing: {
			name: 'playing',
			label: 'playing',
			type: 'boolean',
			initial: false,
		},
		current_preset_index: {
			name: 'current_preset_index',
			label: 'Current Preset Index',
			type: 'integer',
			initial: -1,
			tip: 'Index of the currently active preset',
		},
		next_preset_index: {
			name: 'next_preset_index',
			label: 'Next Preset Index',
			type: 'integer',
			initial: -1,
			tip: 'Index of the preset being transitioned to',
		},
	},
	additionalProperties: false,
}

export const initial_playback_values = {}

Object.keys(playback_schema.properties).forEach(key => {
	initial_playback_values[key] = playback_schema.properties[key].initial
})

export default playback_schema
